export default "__VITE_ASSET__aRjSsZPf__"